export type CartSavedBaseEvent = typeof CART_SAVED_BASE_EVENT;

export const CART_SAVED_BASE_EVENT = `cart:saved`;

export const CART_SAVED_EVENT = <const>{
	CREATE_PDF: `${CART_SAVED_BASE_EVENT}:createPDF`,
	CREATE_PDF_SHARE_LINK: `${CART_SAVED_BASE_EVENT}:createPDF:shareLink`,
	CREATE_PDF_DOWNLOAD: `${CART_SAVED_BASE_EVENT}:createPDF:download`,
	CREATE_TMS_OBJECT_PACKAGE: `${CART_SAVED_BASE_EVENT}:create:tmsObjectPackage`,
	DELETE: `${CART_SAVED_BASE_EVENT}:delete:react`,
	DOWNLOAD: `${CART_SAVED_BASE_EVENT}:download`,
	DUPLICATE: `${CART_SAVED_BASE_EVENT}:duplicate`,
	MANAGE_ARCHIVE: `${CART_SAVED_BASE_EVENT}:manage:archive`,
	MANAGE_ARCHIVE_ARCHIVE: `${CART_SAVED_BASE_EVENT}:manage:archive:archive`,
	MANAGE_ARCHIVE_UNARCHIVE: `${CART_SAVED_BASE_EVENT}:manage:archive:unarchive`,
	MANAGE_EXPIRATION: `${CART_SAVED_BASE_EVENT}:manage:expiration`,
	MENU: `${CART_SAVED_BASE_EVENT}:menu`,
	SHARE_LINK: `${CART_SAVED_BASE_EVENT}:share:link`,
	SHARE_TEAM_ACCESS: `${CART_SAVED_BASE_EVENT}:share:teamAccess`,
	RENAME: `${CART_SAVED_BASE_EVENT}:rename`,
	REMOVE_ASSET: `${CART_SAVED_BASE_EVENT}:removeAssets`,
	REMOVE_SELECTED_ASSETS: `${CART_SAVED_BASE_EVENT}:removeSelectedAssets`,
	REVIEW: `${CART_SAVED_BASE_EVENT}:review`,
	TOGGLE_FAVORITE: `${CART_SAVED_BASE_EVENT}:toggle:favorite`,
};
